import React, { forwardRef } from 'react';

import { START_OF_DAY, END_OF_DAY } from '@vlabs/shared/config';
import { Control } from '@vlabs/uikit';
import { parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';

import st from './popovers.module.sass';
import { useCardsFilters } from '../useCardsFilters';

function DateFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useTranslation();
  const { filters, updateFilters } = useCardsFilters();

  const updateCreateTimeFrom = (dates: Date[] | null) => {
    const [createTimeGte] = dates ?? [];
    updateFilters({ create_time__gte: createTimeGte?.toISOString() });
  };
  const updateCreateTimeTo = (dates: Date[] | null) => {
    const [createTimeLt] = dates ?? [];
    updateFilters({ create_time__lt: createTimeLt?.toISOString() });
  };

  return (
    <PopoverWithButton
      {...props}
      onClickReset={() => updateFilters({
        create_time__gte: undefined,
        create_time__lt: undefined,
      })}
      ref={ref}
    >
      <div className={st.DateInputWrapper}>
        <Control.DateInput
          enableTime
          id="create_time__gte"
          isClearable
          label={t('from_label') ?? ''}
          name="create_time__gte"
          onChange={updateCreateTimeFrom}
          options={START_OF_DAY}
          value={filters.create_time__gte ? parseISO(filters.create_time__gte) : ''}
        />
      </div>
      <div className={st.DateInputWrapper}>
        <Control.DateInput
          enableTime
          id="create_time__lt"
          isClearable
          label={t('to_label') ?? ''}
          name="create_time__lt"
          onChange={updateCreateTimeTo}
          options={END_OF_DAY}
          value={filters.create_time__lt ? parseISO(filters.create_time__lt) : ''}
        />
      </div>
    </PopoverWithButton>
  );
}

const DateFilterPopoverWithRef = forwardRef(DateFilterPopover);
export { DateFilterPopoverWithRef as DateFilterPopover };
